module.exports = __webpack_public_path__ + "static/welcome-banner-022ca4e108f73bb359ef57f7387daaee.jpg";